<template>
  <div style="width: 1200px; margin: auto">
    <div class="top">
      <el-image :src="banner" fit="fill" class="serviecbanner">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div>
      <div v-for="(item, index) in serviceList" :key="index">
        <div class="center">
          <el-col :span="5">
            <el-image :src="item.icon" fit="fill">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-col>
          <el-col :span="19">
            <div class="center_right">
              <div class="center_right_top">
                <h2>{{ item.title }}</h2>
                <el-tooltip
                  :content="item.tip"
                  placement="right-start"
                  effect="light"
                >
                  <el-image
                    :src="require('@/assets/images/wenhao.png')"
                    fit="fill"
                  >
                    <!-- <el-tooltip class="item" effect="dark" content="item.tip" placement="right-start"> -->
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </el-tooltip>
             
               
               
              </div>

              <div class="content">{{ item.content }}</div>
               
         <!-- <div class="details" v-html="item.details"></div> -->
              
              <button class="btn" @click="handleInter(item.id)">
                立即进入
              </button>
            </div>
          </el-col>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getServiceList,details, } from "@/api/xunyou";
export default {
  name: "service",

  data() {
    return {
      serviceList: [],
      banner: "",
      type: "",
      navId:""
    };
  },
  created() {  
       this.type = this.$route.query.type;
        this.navId=this.$route.query.navId
    this.getlist();
  },
  methods: {
   
    //获取服务类数据
    getlist() {
      getServiceList({ type: this.type ,navId:this.navId}).then((res) => {
        if(res.data.banner===''){
          if(this.type==1){
            this.banner=require('@/assets/images/serviesbj.jpg')
          }else {
             this.banner=require('@/assets/images/baoxian.jpg')
          }
        }else {
          this.banner=res.data.banner
        }
        if(res.data.length!==0){
 this.serviceList = res.data.list;
        }else {
  this.$message('暂无数据');
        }
      });
    },
    //立即进入
    handleInter(id) {
      this.$router.push(`/serviceGoods?topicId=${id}&pageType=${this.type}`);
    },
  },

  watch: {
    $route(n, o) {
      console.log(n.fullPath,"fullpath",o.fullPath,"o.fullpath");
      //debugger
      if (n.fullPath !== o.fullPath) {
        //监听路由参数是否变化
        // this.bannerImg = this.$route.query.bannerImg;
        this.type = this.$route.query.type;
        this.navId=this.$route.query.navId
        //  this.reload()
        this.getlist(); //methods中封装的加载数据函数
      }
    },
  },
};
</script>
<style lang="less" scoped>
// background-color: pink;

.top {
  margin-top: 10px;
  .serviecbanner {
    width: 1200px;
    height: 350px;
  }
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 940px;
  padding-top: 20px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
  border-bottom: 1px #ddd dashed;
  padding-bottom: 20px;
  .el-image {
    width: 150px;
    height: 150px;
    margin-left: 20px;
    margin-top: 20px;
  }

  .center_right {
    display: flex;
    flex-direction: column;
    align-items: left;

    .center_right_top {
      display: flex;

      h2 {
        height: 48px;
        font-size: 24px;
        color: #000;
        line-height: 48px;
      }
      .el-image {
        cursor: pointer;
        width: 22px;
        height: 22px;
        line-height: 48px;
        margin-top: 12px;
        margin-left: 10px;
      }
    }
.details{
  margin-top: 10px;
  display: flex;
}
    .btn {
      display: block;
      width: 150px;
      height: 40px;
      background: #f90;
      font-size: 16px;
      color: #fff;
      line-height: 30px;
      text-align: center;
      border: 2px #f0f0f0 solid;
      margin-top: 10px;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/service/index.vue